import axios from 'axios';
import qs from 'qs';
import {userLogout} from "./actions";

// action types

export const START_ADMIN_USER_LOGIN = 'START_ADMIN_USER_LOGIN';
export const START_ADMIN_USER_LOGOUT = 'START_ADMIN_USER_LOGOUT';
export const ADMIN_USER_AUTHENTICATED = 'ADMIN_USER_AUTHENTICATED';
export const ADMIN_USER_LOGOUT = 'ADMIN_USER_LOGOUT';
export const ADMIN_LOGIN_ERROR = 'ADMIN_LOGIN_ERROR';

export const UPLOAD_FILE = 'UPLOAD_FILE';
export const START_UPLOAD = 'START_UPLOAD';
export const UPLOAD_ERROR = 'UPLOAD_ERROR';

export const FETCHING_DATA = 'FETCHING_DATA';
export const DATA_FETCHED = 'DATA_FETCHED';
export const ERROR_FETCHING = 'ERROR_FETCHING';

export const FETCHING_ITEM_DATA = 'FETCHING_ITEM_DATA';
export const ITEM_DATA_FETCHED = 'ITEM_DATA_FETCHED';
export const ERROR_FETCHING_ITEM = 'ERROR_FETCHING_ITEM';

export const FETCHING_CONTACT = 'FETCHING_CONTACT';
export const CONTACT_FETCHED = 'CONTACT_FETCHED';
export const ERROR_FETCHING_CONTACT = 'ERROR_FETCHING_CONTACT';

export const UPDATING_ITEM_DATA = 'UPDATING_ITEM_DATA';
export const ITEM_DATA_UPDATED = 'ITEM_DATA_UPDATED';
export const ERROR_UPDATING_ITEM = 'ERROR_UPDATING_ITEM';

export const UPDATING_CONTACT = 'UPDATING_CONTACT';
export const CONTACT_UPDATED = 'CONTACT_UPDATED';
export const ERROR_UPDATING_CONTACT = 'ERROR_UPDATING_CONTACT';

export const UPDATING_ITEM_FILES_DATA = 'UPDATING_ITEM_FILES_DATA';
export const ITEM_FILES_DATA_UPDATED = 'ITEM_FILES_DATA_UPDATED';
export const ERROR_UPDATING_ITEM_FILES = 'ERROR_UPDATING_ITEM_FILES';

export const CREATING_ITEM_DATA = 'CREATING_ITEM_DATA';
export const ITEM_DATA_CREATED = 'ITEM_DATA_CREATED';
export const ERROR_CREATING_ITEM = 'ERROR_CREATING_ITEM';

export const DELETING_ITEM_DATA = 'DELETING_ITEM_DATA';
export const ITEM_DATA_DELETED = 'ITEM_DATA_DELETED';
export const ERROR_DELETING_ITEM = 'ERROR_DELETING_ITEM';

export const FILTERING_DATA = 'FILTERING_DATA';
export const DATA_FILTERED = 'DATA_FILTERED';
export const ERROR_FILTERING = 'ERROR_FILTERING';

export const FETCHING_AWS_DATA = 'FETCHING_AWS_DATA';
export const AWS_DATA_FETCHED = 'AWS_DATA_FETCHED';
export const ERROR_FETCHING_AWS = 'ERROR_FETCHING_AWS';

export const FETCHING_CONTACTS = 'FETCHING_CONTACTS';
export const CONTACTS_FETCHED = 'CONTACTS_FETCHED';
export const ERROR_FETCHING_CONTACTS = 'ERROR_FETCHING_CONTACTS';

export const FETCHING_CONTACT_RELATIONSHIPS = 'FETCHING_CONTACT_RELATIONSHIPS';
export const CONTACT_RELATIONSHIPS_FETCHED = 'CONTACT_RELATIONSHIPS_FETCHED';
export const ERROR_FETCHING_CONTACT_RELATIONSHIPS = 'ERROR_FETCHING_CONTACT_RELATIONSHIPS';

export const FETCHING_INVESTOR_RELATIONSHIPS = 'FETCHING_INVESTOR_RELATIONSHIPS';
export const INVESTOR_RELATIONSHIPS_FETCHED = 'INVESTOR_RELATIONSHIPS_FETCHED';
export const ERROR_FETCHING_INVESTOR_RELATIONSHIPS = 'ERROR_FETCHING_INVESTOR_RELATIONSHIPS';

export const FETCHING_INVESTOR_PRIVATE_FUNDS = 'FETCHING_INVESTOR_PRIVATE_FUNDS';
export const INVESTOR_PRIVATE_FUNDS_FETCHED = 'INVESTOR_PRIVATE_FUNDS_FETCHED';
export const ERROR_FETCHING_INVESTOR_PRIVATE_FUNDS = 'ERROR_FETCHING_INVESTOR_PRIVATE_FUNDS';

export const TITLE_CREATED = 'TITLE_CREATED';
export const CREATING_TITLE = 'CREATING_TITLE';
export const ERROR_CREATING_TITLE = 'ERROR_CREATING_TITLE';

export const DATA_MERGED = 'DATA_MERGED';
export const MERGING_DATA = 'MERGING_DATA';
export const ERROR_MERGING = 'ERROR_MERGING';

export const FETCHING_LATEST_PROFILES = 'FETCHING_LATEST_PROFILES';
export const LATEST_PROFILES_FETCHED = 'LATEST_PROFILES_FETCHED';
export const ERROR_FETCHING_LATEST_PROFILES = 'ERROR_FETCHING_LATEST_PROFILES';

export const DELETING_RIA_CONTACT_PHOTO = 'DELETING_RIA_CONTACT_PHOTO';
export const RIA_CONTACT_PHOTO_DELETED = 'RIA_CONTACT_PHOTO_DELETED';
export const ERROR_DELETING_RIA_CONTACT_PHOTO = 'ERROR_DELETING_RIA_CONTACT_PHOTO';

export const PRIVATE_FUND_FETCHED = 'PRIVATE_FUND_FETCHED';
export const FETCHING_PRIVATE_FUND = 'FETCHING_PRIVATE_FUND';
export const ERROR_FETCHING_PRIVATE_FUND = 'ERROR_FETCHING_PRIVATE_FUND';

export const ADVISORS_FETCHED = 'ADVISORS_FETCHED';
export const FETCHING_ADVISORS = 'FETCHING_ADVISORS';
export const ERROR_FETCHING_ADVISORS = 'ERROR_FETCHING_ADVISORS';

export const OWNERS_FETCHED = 'OWNERS_FETCHED';
export const FETCHING_OWNERS = 'FETCHING_OWNERS';
export const ERROR_FETCHING_OWNERS = 'ERROR_FETCHING_OWNERS';

export const UPDATING_PRIVATE_FUND_DATA = 'UPDATING_PRIVATE_FUND_DATA';
export const PRIVATE_FUND_DATA_UPDATED = 'PRIVATE_FUND_DATA_UPDATED';
export const ERROR_UPDATING_PRIVATE_FUND = 'ERROR_UPDATING_PRIVATE_FUND';

export const DELETING_PRIVATE_FUND_PHOTO = 'DELETING_PRIVATE_FUND_PHOTO';
export const RIA_PRIVATE_FUND_PHOTO_DELETED = 'RIA_PRIVATE_FUND_PHOTO_DELETED';
export const ERROR_DELETING_PRIVATE_FUND_PHOTO = 'ERROR_DELETING_PRIVATE_FUND_PHOTO';

export const FETCHING_RIA_INVESTOR_ADDITIONAL_LOCATIONS = 'FETCHING_RIA_INVESTOR_ADDITIONAL_LOCATIONS';
export const RIA_INVESTOR_ADDITIONAL_LOCATIONS_FETCHED = 'RIA_INVESTOR_ADDITIONAL_LOCATIONS_FETCHED';
export const ERROR_FETCHING_RIA_INVESTOR_ADDITIONAL_LOCATIONS = 'ERROR_FETCHING_RIA_INVESTOR_ADDITIONAL_LOCATIONS';

export const PAGE_CHANGED = 'PAGE_CHANGED';

export const FILTER_CHANGED = 'FILTER_CHANGED';

export const ACTIONS_CHANGED = 'ACTIONS_CHANGED';

export const ACTIONS_ADVISORS_CHANGED = 'ACTIONS_ADVISORS_CHANGED';

export const ACTIONS_PRIVATE_FUNDS_CHANGED = 'ACTIONS_PRIVATE_FUNDS_CHANGED';

export const ACTIONS_ADDITIONAL_LOCATIONS_CHANGED = 'ACTIONS_ADDITIONAL_LOCATIONS_CHANGED';

export const ACTIONS_OWNERS_CHANGED = 'ACTIONS_OWNERS_CHANGED';

// action creators

export function adminUserAuthenticated(adminUserSession) {
  return {
    type: ADMIN_USER_AUTHENTICATED,
    adminUserSession: { ...adminUserSession }
  }
}

export function adminUserLogout(adminUserSession) {
  return {
    type: ADMIN_USER_LOGOUT,
    adminUserSession
  }
}

export function loginError(error) {
  return {
    type: ADMIN_LOGIN_ERROR,
    error
  }
}

export function uploadFile(response) {
  return {
    type: UPLOAD_FILE,
    adminUpload: response
  }
}

export function fetchData(response) {
  return {
    type: DATA_FETCHED,
    adminFetch: response
  }
}

export function fetchItemData(response) {
  return {
    type: ITEM_DATA_FETCHED,
    adminFetchItem: response
  }
}

export function fetchContact(response) {
  return {
    type: CONTACT_FETCHED,
    adminFetchContact: response
  }
}

export function updateItemData(response) {
  return {
    type: ITEM_DATA_UPDATED,
    adminUpdateItem: response
  }
}

export function mergeData(response) {
  return {
    type: DATA_MERGED,
    adminMergeItem: response
  }
}

export function createTitle(response) {
  return {
    type: TITLE_CREATED,
    adminCreateTitle: response
  }
}
export function createNotification(response) {
  return {
    type: TITLE_CREATED,
    adminCreateTitle: response
  }
}

export function updateContactData(response) {
  return {
    type: CONTACT_UPDATED,
    adminUpdateContact: response
  }
}

export function updateItemWithFilesData(response) {
  return {
    type: ITEM_FILES_DATA_UPDATED,
    adminUpdateItemWithFiles: response
  }
}

export function createItemData(response) {
  return {
    type: ITEM_DATA_CREATED,
    adminCreateItem: response
  }
}

export function deleteItemData(response) {
  return {
    type: ITEM_DATA_DELETED,
    adminDeleteItem: response
  }
}

export function filterData(response) {
  return {
    type: DATA_FILTERED,
    adminFilterItems: response
  }
}

export function awsData(response) {
  return {
    type: AWS_DATA_FETCHED,
    adminAwsItems: response
  }
}

export function contactsData(response) {
  return {
    type: CONTACTS_FETCHED,
    adminInvestorContacts: response
  }
}

export function contactRelationships(response) {
  return {
    type: CONTACT_RELATIONSHIPS_FETCHED,
    adminContactRelationships: response
  }
}

export function investorRelationships(response) {
  return {
    type: INVESTOR_RELATIONSHIPS_FETCHED,
    adminRiaInvestorRelationships: response
  }
}

export function fetchAdditionalOfficeLocations(response){
  return {
    type: RIA_INVESTOR_ADDITIONAL_LOCATIONS_FETCHED,
    adminRiaInvestorAdditionalOfficeLocations: response
  }
}

export function investorPrivateFunds(response) {
  return {
    type: INVESTOR_PRIVATE_FUNDS_FETCHED,
    adminRiaInvestorPrivateFunds: response
  }
}

export function investorOwners(response) {
  return {
    type: OWNERS_FETCHED,
    adminRiaInvestorOwners: response
  }
}

export function pageChanged(page) {
  return {
    type: PAGE_CHANGED,
    adminPage: page
  }
}

export function filtersChanged(filter) {
  return {
    type: FILTER_CHANGED,
    adminFilter: filter
  }
}

export function fetchPrivateFundData(response) {
  return {
    type: PRIVATE_FUND_FETCHED,
    adminPrivateFundFetch: response
  }
}

export function investorContactsSortAndPage(params) {
  return {
    type: ACTIONS_CHANGED,
    investorContactsSortAndPage: params
  }
}

export function privateFundAdvisorsSortAndPage(params) {
  return {
    type: ACTIONS_ADVISORS_CHANGED,
    privateFundAdvisorsSortAndPage: params
  }
}

export function advisorPrivateFundsSortAndPage(params) {
  return {
    type: ACTIONS_PRIVATE_FUNDS_CHANGED,
    advisorPrivateFundsSortAndPage: params
  }
}

export function investorAdditionalOfficeLocationsSortAndPage(params) {
  return {
    type: ACTIONS_ADDITIONAL_LOCATIONS_CHANGED,
    investorAdditionalOfficeLocations: params
  }
}

export function investorEntityOwnersSortAndPage(params) {
  return {
    type: ACTIONS_OWNERS_CHANGED,
    investorEntityOwnersSortAndPage: params
  }
}

export function fetchLatestVisitedProfiles(response) {
  return {
    type: LATEST_PROFILES_FETCHED,
    latestVisitedProfiles: response
  }
}

export function deleteRiaContactPhoto(response) {
  return {
    type: RIA_CONTACT_PHOTO_DELETED,
    deletedRiaContactPhoto: response
  }
}

export function fetchPrivateFundAdvisors(response) {
  return {
    type: ADVISORS_FETCHED,
    adminPrivateFundAdvisors: response
  }
}

export function updatePrivateFund(response) {
  return {
    type: PRIVATE_FUND_DATA_UPDATED,
    adminUpdatePrivateFund: response
  }
}

export function deletePrivateFundPhoto(response) {
  return {
    type: RIA_PRIVATE_FUND_PHOTO_DELETED,
    deletedPrivateFundPhoto: response
  }
}

export const handleLogin = params => {
  return async dispatch => {
    try {
      dispatch({
        type: START_ADMIN_USER_LOGIN //MUESTRA EL LOADING....
      });
      const response = await axios.post('/admin_users/sign_in', { admin_user: { ...params } });

      dispatch(adminUserAuthenticated(response.data));
    } catch (e) {
      dispatch(loginError('error'));
    }
  };
};

export const handleLogout = params => {
  return async dispatch => {
    try {
      dispatch({
        type: START_ADMIN_USER_LOGOUT //MUESTRA EL LOADING....
      });
      if (params) {
        const response = await axios.delete('/admin_users/sign_out', { headers: { 'X-Admin-User-Email': params.email, 'X-Admin-User-Token': params.token } });
        dispatch(adminUserLogout(response.data));
      } else {
        dispatch(adminUserLogout({}));
      }
    } catch (e) {
      dispatch(adminUserAuthenticated(params));
    }
  };
};

export const handleFileSubmit = (session, fileUploadPath, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: START_UPLOAD 
      });

      let data = '';

      if (params.type === 'aws') {
        data = qs.stringify({
          csv_file: params.path,
          type: 'aws',
          process: params.process,
        });
      } else {
        data = new FormData();
        data.append('csv_file', params.path);
        data.append('type', 'file');
        data.append('process', params.process);
      }

      const response = await axios.post(
        fileUploadPath,
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(uploadFile(response.data));
    } catch (e) {
      dispatch({
        type: UPLOAD_ERROR,
        adminUpload: {
          status: 'error',
          message: 'Error uploading file'
        }
      });
    }
  };
}

export const handleDataFetch = (session, dataFetchPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_DATA 
      });

      const response = await axios.get(
        dataFetchPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(fetchData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING,
        adminFetch: {
          status: 'error',
          message: 'Error fetching data'
        }
      });
    }
  };
}

export const handleDataItemFetch = (session, dataItemFetchPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_ITEM_DATA 
      });

      const response = await axios.get(
        dataItemFetchPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(fetchItemData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_ITEM,
        adminFetchItem: {
          status: 'error',
          message: 'Error fetching data'
        }
      });
    }
  };
}

export const handleContactFetch = (session, dataContactFetchPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_CONTACT 
      });

      const response = await axios.get(
        dataContactFetchPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(fetchContact(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_CONTACT,
        adminFetchContact: {
          status: 'error',
          message: 'Error fetching data'
        }
      });
    }
  };
}

export const handleProcessItem = (session, dataItemProcessPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_ITEM_DATA 
      });

      const response = await axios.put(
        dataItemProcessPath,
        qs.stringify(data),
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(updateItemData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_ITEM,
        adminUpdateItem: {
          status: 'error',
          message: 'Error updating data'
        }
      });
    }
  };
}

export const RESET_UPDATING_ITEM = 'RESET_UPDATING_ITEM';

export const handleResetUpdatingItem = () => {
  return dispatch => {
    dispatch({
      type: RESET_UPDATING_ITEM,
    })
  }
}

export const handleCreateTitle = (session, dataItemProcessPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: CREATING_TITLE 
      });

      const response = await axios.post(
        dataItemProcessPath,
        qs.stringify(data),
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(createTitle(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_CREATING_TITLE,
        adminUpdateItem: {
          status: 'error',
          message: 'Error updating data'
        }
      });
    }
  };
}

export const RUN_PROGRESSIVE_ALGO = 'RUN_PROGRESSIVE_ALGO';
export const RUNNING_PROGRESSIVE_ALGO = 'RUNNING_PROGRESSIVE_ALGO';
export const ERROR_RUNNING_PROGRESSIVE_ALGO = 'ERROR_RUNNING_PROGRESSIVE_ALGO';

export function runProgressistAlgo(response) {
  return {
    type: RUN_PROGRESSIVE_ALGO,
    runProgressistAlgo: response
  }
}

export const handleRunProgressistAlgo = (session) => {
  return async dispatch => {
    try {
      dispatch({
        type: RUNNING_PROGRESSIVE_ALGO 
      });

      const response = await axios.post(
        '/v1/admin/progressive_terms/run_algorithm',
        {},
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(runProgressistAlgo(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_RUNNING_PROGRESSIVE_ALGO,
        runProgressistAlgo: {
          status: 'error',
          message: 'Error running algo data'
        }
      });
    }
  };
}

export const handleCreateItem = (session, dataItemCreatePath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: CREATING_ITEM_DATA 
      });

      const response = await axios.post(
        dataItemCreatePath,
        qs.stringify(data),
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(createItemData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_CREATING_ITEM,
        adminCreateItem: {
          status: 'error',
          message: 'Error updating data'
        }
      });
    }
  };
}

export const handleDeleteItem = (session, dataItemDeletePath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: CREATING_ITEM_DATA 
      });

      const response = await axios.delete(
        dataItemDeletePath,
        {
          data: qs.stringify(data),
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(deleteItemData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_CREATING_ITEM,
        adminDeleteItem: {
          status: 'error',
          message: 'Error updating data'
        }
      });
    }
  };
}

export const handleFilterItems = (session, dataItemFilterPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FILTERING_DATA 
      });

      const response = await axios.get(
        dataItemFilterPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(filterData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FILTERING,
        adminFilterItems: {
          status: 'error',
          message: 'Error filtering data'
        }
      });
    }
  };
}

export const handleFetchAwsData = (session, dataAwsPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_AWS_DATA 
      });

      const response = await axios.get(
        dataAwsPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(awsData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_AWS,
        adminAwsItems: {
          status: 'error',
          message: 'Error accessing data'
        }
      });
    }
  };
}

export const handleFetchRiaContactsFromRiaInvestor = (session, investorContactsPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_CONTACTS 
      });

      const response = await axios.get(
        investorContactsPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(contactsData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_CONTACTS,
        adminInvestorContacts: {
          status: 'error',
          message: 'Error fetching data'
        }
      });
    }
  };
}

export const handleFetchRiaContactRelationships = (session, contactRelationshipsPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_CONTACT_RELATIONSHIPS 
      });

      const response = await axios.get(
        contactRelationshipsPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(contactRelationships(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_CONTACT_RELATIONSHIPS,
        adminContactRelationships: {
          status: 'error',
          message: 'Error fetching relationships'
        }
      });
    }
  };
}

export const handleFetchRiaInvestorRelationships = (session, investorRelationshipsPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_INVESTOR_RELATIONSHIPS 
      });

      const response = await axios.get(
        investorRelationshipsPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(investorRelationships(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_INVESTOR_RELATIONSHIPS,
        adminRiaInvestorRelationships: {
          status: 'error',
          message: 'Error fetching relationships'
        }
      });
    }
  };
}

export const handleFetchRiaInvestorPrivateFunds = (session, investorPrivateFundsPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_INVESTOR_PRIVATE_FUNDS 
      });

      const response = await axios.get(
        investorPrivateFundsPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(investorPrivateFunds(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_INVESTOR_PRIVATE_FUNDS,
        adminRiaInvestorPrivateFunds: {
          status: 'error',
          message: 'Error fetching private funds'
        }
      });
    }
  };
}

export const handleFetchRiaInvestorEntityOwners = (session, entityOwnersPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_OWNERS 
      });

      const response = await axios.get(
        entityOwnersPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(investorOwners(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_OWNERS,
        adminRiaInvestorOwners: {
          status: 'error',
          message: 'Error fetching owners'
        }
      });
    }
  };
}

export const handleProcessItemWithFiles = (session, dataItemProcessPath, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_ITEM_FILES_DATA 
      });

      params = params.ria_contact

      let data = new FormData();
      data.append('ria_contact[email]', params.email);
      data.append('ria_contact[mobile_phone_number]', params.mobile_phone_number);
      data.append('ria_contact[additional_phone_number]', params.additional_phone_number);
      data.append('ria_contact[ext_additional_phone_number]', params.ext_additional_phone_number);
      data.append('ria_contact[linkedin_profile_url]', params.linkedin_profile_url);
      data.append('ria_contact[ria_private_bio]', params.private_bio);
      data.append('ria_contact[secondary_email]', params.secondary_email);
      data.append('ria_contact[gender]', params.gender);
      data.append('ria_contact[personal_email]', params.personal_email);
      data.append('ria_contact[dob_month]', params.dob_month);
      data.append('ria_contact[dob_day]', params.dob_day);
      data.append('ria_contact[dob_year]', params.dob_year);
      data.append('ria_contact[office_phone_number]', params.office_phone_number);
      data.append('ria_contact[ext_office_phone_number]', params.ext_office_phone_number);
      data.append('ria_contact[contact_employment_histories_attributes]', JSON.stringify(params.contact_employment_histories_attributes));
      data.append('ria_contact[contact_employment_history_broker_dealers_attributes]', JSON.stringify(params.contact_employment_history_broker_dealers_attributes));
      data.append('ria_contact[ria_contact_universities_attributes]', JSON.stringify(params.ria_contact_universities_attributes));
      data.append('ria_contact[ria_contact_current_company_data_attributes]', JSON.stringify(params.ria_contact_current_company_data_attributes));
      data.append('ria_contact[ria_contact_ai_dentified_datum_attributes]', JSON.stringify(params.ria_contact_ai_dentified_datum_attributes));
      data.append('ria_contact[title_id]', params.title_id);
      data.append('ria_contact[automated_title_id]', params.automated_title_id);
      data.append('ria_contact[automated_phone]', params.automated_phone);
      data.append('ria_contact[automated_email]', params.automated_email);
      data.append('ria_contact[achievement_ids]', JSON.stringify(params.achievement_ids));
      data.append('ria_contact[contact_bio_url]', params.contact_bio_url);
      data.append('ria_contact[file_first_name]', params.file_first_name);
      data.append('ria_contact[file_last_name]', params.file_last_name);
      data.append('ria_contact[file_first_name_other]', params.file_first_name_other);
      data.append('ria_contact[file_first_name_changed]', params.file_first_name_changed);
      data.append('ria_contact[file_last_name_changed]', params.file_last_name_changed);
      data.append('ria_contact[file_first_name_other_changed]', params.file_first_name_other_changed);

      if (params.investors_for_domain && Array.isArray(params.investors_for_domain)) {
        params.investors_for_domain.forEach(id => {
          data.append('ria_contact[investors_for_domain][]', id);
        });
      }

      if (params.photo != undefined) {
        data.append('ria_contact[photo]', params.photo);
      }

      if (params.country_prefix_office_phone_number !== undefined) {
        data.append('ria_contact[country_prefix_office_phone_number]', params.country_prefix_office_phone_number);
      }

      if (params.country_prefix_mobile_phone_number !== undefined) {
        data.append('ria_contact[country_prefix_mobile_phone_number]', params.country_prefix_mobile_phone_number);
      }

      if (params.country_prefix_additional_phone_number !== undefined) {
        data.append('ria_contact[country_prefix_additional_phone_number]', params.country_prefix_additional_phone_number);
      }

      if (params.unsync_person !== undefined) {
        data.append('unsync_person', params.unsync_person);
      }

      const response = await axios.put(
        dataItemProcessPath,
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(updateItemWithFilesData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_ITEM_FILES,
        adminUpdateItemWithFiles: {
          status: 'error',
          message: 'Error updating data'
        }
      });
    }
  };
}

export const RESET_UPDATING_ITEM_WITH_FILES = 'RESET_UPDATING_ITEM_WITH_FILES';

export const handleResetUpdatingItemWithFiles = () => {
  return dispatch => {
    dispatch({
      type: RESET_UPDATING_ITEM_WITH_FILES,
    })
  }
}

export const handleProcessContactItem = (session, dataItemProcessPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_CONTACT 
      });

      const response = await axios.put(
        dataItemProcessPath,
        qs.stringify(data),
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(updateContactData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_CONTACT,
        adminUpdateItem: {
          status: 'error',
          message: 'Error updating data'
        }
      });
    }
  };
}

export const handleProcessMergeItems = (session, dataItemProcessPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: MERGING_DATA 
      });

      const response = await axios.post(
        dataItemProcessPath,
        qs.stringify(data),
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(mergeData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_MERGING,
        adminUpdateItem: {
          status: 'error',
          message: 'Error updating data'
        }
      });
    }
  };
}

export const handleFetchLatestVisitedProfiles = (session) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_LATEST_PROFILES 
      });

      const response = await axios.get(
        '/v1/admin/profile_visits',
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(fetchLatestVisitedProfiles(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_LATEST_PROFILES,
        adminUpdateItem: {
          status: 'error',
          message: 'Error updating data'
        }
      });
    }
  };
}

export const handleDeleteRiaContactPhoto = (session, deletePhotoPath) => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETING_RIA_CONTACT_PHOTO 
      });

      const response = await axios.delete(
        deletePhotoPath,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(deleteRiaContactPhoto(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_DELETING_RIA_CONTACT_PHOTO,
        adminUpdateItem: {
          status: 'error',
          message: 'Error deleting photo'
        }
      });
    }
  };
}

export const handleFetchPrivateFund = (session, privateFundPath) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_PRIVATE_FUND 
      });

      const response = await axios.get(
        privateFundPath,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(fetchPrivateFundData(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_PRIVATE_FUND,
        adminPrivateFundFetch: {
          status: 'error',
          message: 'Error fetching private fund'
        }
      });
    }
  };
}

export const handleFetchPrivateFundAdvisors = (session, privateFundAdvisorsPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_ADVISORS 
      });

      const response = await axios.get(
        privateFundAdvisorsPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(fetchPrivateFundAdvisors(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_ADVISORS,
        adminPrivateFundAdvisors: {
          status: 'error',
          message: 'Error fetching advisors'
        }
      });
    }
  };
}

export const handleProcessPrivateFund = (session, dataItemProcessPath, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_PRIVATE_FUND_DATA 
      });

      params = params.private_fund

      let data = new FormData();

      if (params.photo != undefined) {
        data.append('private_fund[photo]', params.photo);
      }

      const response = await axios.put(
        dataItemProcessPath,
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(updatePrivateFund(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_PRIVATE_FUND,
        adminUpdateItem: {
          status: 'error',
          message: 'Error updating data'
        }
      });
    }
  };
}

export const handleDeletePrivateFundPhoto = (session, deletePhotoPath) => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETING_PRIVATE_FUND_PHOTO 
      });

      const response = await axios.delete(
        deletePhotoPath,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );
      dispatch(deletePrivateFundPhoto(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_DELETING_PRIVATE_FUND_PHOTO,
        adminUpdateItem: {
          status: 'error',
          message: 'Error deleting photo'
        }
      });
    }
  };
}

export const handleFetchaRiaInvestorAdditionalOfficeLocations = (session, additionalOfficeLocationsPath, data = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_RIA_INVESTOR_ADDITIONAL_LOCATIONS 
      });

      const response = await axios.get(
        additionalOfficeLocationsPath,
        {
          params: data,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(fetchAdditionalOfficeLocations(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_RIA_INVESTOR_ADDITIONAL_LOCATIONS,
        adminRiaInvestorAdditionalOfficeLocations: {
          status: 'error',
          message: 'Error fetching additional locations'
        }
      });
    }
  };
}

export const FETCHING_RIA_CONTACT_REG_ORGS = 'FETCHING_RIA_CONTACT_REG_ORGS';
export const RIA_CONTACT_REG_ORGS_FETCHED = 'RIA_CONTACT_REG_ORGS_FETCHED';
export const ERROR_FETCHING_RIA_CONTACT_REG_ORGS = 'ERROR_FETCHING_RIA_CONTACT_REG_ORGS';

export function fetchRegulatoryOrganizations(response) {
  return {
    type: RIA_CONTACT_REG_ORGS_FETCHED,
    regulatoryOrganizations: response
  }
}

export const handleFetchRegulatoryOrganizations = (session, riaContactId, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_RIA_CONTACT_REG_ORGS 
      });

      const response = await axios.get(
        `/v1/admin/ria_contacts/${riaContactId}/regulatory_organizations`,
        {
          params,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(fetchRegulatoryOrganizations(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_RIA_CONTACT_REG_ORGS,
        regulatoryOrganizations: {
          status: 'error',
          message: 'Error fetching regulatory organizations'
        }
      });
    }
  };
}

export const FETCHING_RIA_CONTACTS_BROKER_DEALER_STATES = 'FETCHING_RIA_CONTACTS_BROKER_DEALER_STATES';
export const RIA_CONTACTS_BROKER_DEALER_STATES_FETCHED = 'RIA_CONTACTS_BROKER_DEALER_STATES_FETCHED';
export const ERROR_FETCHING_RIA_CONTACTS_BROKER_DEALER_STATES = 'ERROR_FETCHING_RIA_CONTACTS_BROKER_DEALER_STATES';

export function fetchBrokerDealerStates(response) {
  return {
    type: RIA_CONTACTS_BROKER_DEALER_STATES_FETCHED,
    brokerDealerStates: response
  }
}

export const handleFetchBrokerDealerStates = (session, riaContactId, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_RIA_CONTACTS_BROKER_DEALER_STATES 
      });

      const response = await axios.get(
        `/v1/admin/ria_contacts/${riaContactId}/broker_dealer_states`,
        {
          params,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      );

      dispatch(fetchBrokerDealerStates(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_RIA_CONTACTS_BROKER_DEALER_STATES,
        brokerDealerStates: {
          status: 'error',
          message: 'Error fetching Broker Dealer States'
        }
      });
    }
  };
}

///////
export const FETCHING_RIA_INVESTOR_CUSTODIANS = 'FETCHING_RIA_INVESTOR_CUSTODIANS';
export const RIA_INVESTOR_CUSTODIANS_FETCHED = 'RIA_INVESTOR_CUSTODIANS_FETCHED';
export const ERROR_FETCHING_RIA_INVESTOR_CUSTODIANS = 'ERROR_FETCHING_RIA_INVESTOR_CUSTODIANS';

export function investorCustodians(response) {
  return {
    type: RIA_INVESTOR_CUSTODIANS_FETCHED,
    adminRiaInvestorCustodians: response
  }
}

export const handleFetchRiaInvestorCustodians = (session, cancelToken, entityCustodiansPath, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_RIA_INVESTOR_CUSTODIANS 
      });

      const response = await axios.get(
        entityCustodiansPath,
        {
          params,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
          cancelToken
        }
      );

      dispatch(investorCustodians(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_RIA_INVESTOR_CUSTODIANS,
        adminRiaInvestorCustodians: {
          status: 'error',
          message: 'Error fetching custodians'
        }
      });
    }
  };
}

export const ACTION_CUSTODIANS_CHANGED = 'ACTION_CUSTODIANS_CHANGED';

export function investorCustodiansSortAndPage(params) {
  return {
    type: ACTION_CUSTODIANS_CHANGED,
    investorCustodiansSortAndPage: params
  }
}

export const handleCustodiansSortAndPage = (params) => {
  return dispatch => {
    dispatch(investorCustodiansSortAndPage(params))
  }
}


//////

export const handlePageChange = (page) => {
  return dispatch => {
    dispatch(pageChanged(page))
  }
}

export const handleFiltersChange = (filter) => {
  return dispatch => {
    dispatch(filtersChanged(filter))
  }
}

export const handleInvestorContactsSortAndPage = (params) => {
  return dispatch => {
    dispatch(investorContactsSortAndPage(params))
  }
}

export const handlePrivateFundAdvisorsSortAndPage = (params) => {
  return dispatch => {
    dispatch(privateFundAdvisorsSortAndPage(params))
  }
}

export const handleAdvisorPrivateFundsSortAndPage = (params) => {
  return dispatch => {
    dispatch(advisorPrivateFundsSortAndPage(params))
  }
}

export const handleInvestorAdditionalOfficeLocationsSortAndPage = (params) => {
  return dispatch => {
    dispatch(investorAdditionalOfficeLocationsSortAndPage(params))
  }
}

export const handleEntityOwnersSortAndPage = (params) => {
  return dispatch => {
    dispatch(investorEntityOwnersSortAndPage(params))
  }
}

export const FETCHING_FO_RESEARCH_REQUESTS = 'FETCHING_FO_RESEARCH_REQUESTS';
export const FO_RESEARCH_REQUESTS_FETCHED = 'FO_RESEARCH_REQUESTS_FETCHED';
export const ERROR_FETCHING_FO_RESEARCH_REQUESTS = 'ERROR_FETCHING_FO_RESEARCH_REQUESTS';

export function fetchFOResearchRequests(response) {
  return {
    type: FO_RESEARCH_REQUESTS_FETCHED,
    foResearchRequests: response
  }
}

export const handleFetchFOResearchRequests = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_FO_RESEARCH_REQUESTS 
      });

      const response = await axios.get(
        '/v1/admin/research_requests',
        {
          params,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
          cancelToken,
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(fetchFOResearchRequests(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_FO_RESEARCH_REQUESTS,
        foResearchRequests: {
          status: 'error',
          message: 'Error fetching FO Research Requests'
        }
      });
    }
  };
}


export const FETCHING_FO_RESEARCH_REQUEST = 'FETCHING_FO_RESEARCH_REQUEST';
export const FO_RESEARCH_REQUEST_FETCHED = 'FO_RESEARCH_REQUEST_FETCHED';
export const ERROR_FETCHING_FO_RESEARCH_REQUEST = 'ERROR_FETCHING_FO_RESEARCH_REQUEST';

export function fetchFOResearchRequest(response) {
  return {
    type: FO_RESEARCH_REQUEST_FETCHED,
    foResearchRequest: response
  }
}

export const handleFetchFOResearchRequest = (session, cancelToken, id) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_FO_RESEARCH_REQUEST 
      });

      const response = await axios.get(
        `/v1/admin/research_requests/${id}`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
          cancelToken,
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(fetchFOResearchRequest(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_FO_RESEARCH_REQUEST,
        foResearchRequest: {
          status: 'error',
          message: 'Error fetching FO Research Request'
        }
      });
    }
  };
}

export const FETCHING_FEATURE_UPGRADES = 'FETCHING_FEATURE_UPGRADES';
export const FEATURE_UPGRADES_FETCHED = 'FEATURE_UPGRADES_FETCHED';
export const ERROR_FETCHING_FEATURE_UPGRADES = 'ERROR_FETCHING_FEATURE_UPGRADES';

export function fetchFeatureUpgrades(response) {
  return {
    type: FEATURE_UPGRADES_FETCHED,
    featureUpgrades: response
  }
}

export const handleFetchFeatureUpgrades = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_FEATURE_UPGRADES 
      });

      const response = await axios.get(
        '/v1/admin/feature_upgrades',
        {
          params,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
          cancelToken,
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(fetchFeatureUpgrades(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_FEATURE_UPGRADES,
        featureUpgrades: {
          status: 'error',
          message: 'Error fetching Admin Feature Upgrades'
        }
      });
    }
  };
}


export const SAVING_FEATURE_UPGRADE_PARAMS = 'SAVING_FEATURE_UPGRADE_PARAMS';
export const FEATURE_UPGRADE_PARAMS_SAVED = 'FEATURE_UPGRADE_PARAMS_SAVED';
export const ERROR_SAVING_FEATURE_UPGRADE_PARAMS = 'ERROR_SAVING_FEATURE_UPGRADE_PARAMS';

export function saveFeatureUpgradeParams(response) {
  return {
    type: FEATURE_UPGRADE_PARAMS_SAVED,
    featureUpgradeParamsSaved: response
  }
}

export const handleSaveFeatureUpgrade = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVING_FEATURE_UPGRADE_PARAMS 
      });

      let data = new FormData();
      data.append('feature_upgrade[title]', params.title);
      data.append('feature_upgrade[short_description]', params.short_description);
      data.append('feature_upgrade[description]', params.description);
      data.append('feature_upgrade[tag]', params.tag);
      data.append('feature_upgrade[permission]', params.permission);
      data.append('feature_upgrade[status]', params.status);
      data.append('feature_upgrade[url]', params.url);
      if (params.icon != undefined) {
        data.append('feature_upgrade[icon]', params.icon);
      }

      const response = await axios.post(
        `/v1/admin/feature_upgrades`,
        data,
        //qs.stringify({ feature_upgrade: _.isEmpty(formData) ? {} : JSON.stringify(formData) }),
        {
          cancelToken,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(saveFeatureUpgradeParams(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_SAVING_FEATURE_UPGRADE_PARAMS,
        featureUpgradeParamsSaved: {
          status: 'error',
          message: 'Error saving Feature Upgrade params'
        }
      });
    }
  };
}

export const REMOVING_FEATURE_UPGRADE = 'REMOVING_FEATURE_UPGRADE';
export const FEATURE_UPGRADE_REMOVED = 'FEATURE_UPGRADE_REMOVED';
export const ERROR_REMOVING_FEATURE_UPGRADE = 'ERROR_REMOVING_FEATURE_UPGRADE';

export function removeFeatureUpgrade(response) {
  return {
    type: FEATURE_UPGRADE_REMOVED,
    featureUpgradeRemoved: response
  }
}

export const handleRemoveFeatureUpgrade = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: REMOVING_FEATURE_UPGRADE 
      });
      const response = await axios.delete(
        `/v1/admin/feature_upgrades/delete_one`,
        {
          params: {feature_upgrade: params},
          headers: {
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
          cancelToken
        }
      );

      dispatch(removeFeatureUpgrade(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_REMOVING_FEATURE_UPGRADE,
        featureUpgradeRemoved: {
          status: 'error',
          message: 'Error removing Feature Upgrade'
        }
      });
    }
  };
}

export const FETCHING_FEATURE_UPGRADE = 'FETCHING_FEATURE_UPGRADE';
export const FEATURE_UPGRADE_FETCHED = 'FEATURE_UPGRADE_FETCHED';
export const ERROR_FETCHING_FEATURE_UPGRADE = 'ERROR_FETCHING_FEATURE_UPGRADE';

export function fetchFeatureUpgrade(response) {
  return {
    type: FEATURE_UPGRADE_FETCHED,
    featureUpgrade: response
  }
}

export const handleFeatureUpgradeFetch = (session, cancelToken, feature_upgrade_id) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_FEATURE_UPGRADE 
      });

      const response = await axios.get(
        `/v1/admin/feature_upgrades/${feature_upgrade_id}/edit`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
          cancelToken,
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(fetchFeatureUpgrade(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_FEATURE_UPGRADE,
        featureUpgrade: {
          status: 'error',
          message: 'Error fetching Admin Feature Upgrade'
        }
      });
    }
  };
}

export const UPDATING_FEATURE_UPGRADE_PARAMS = 'UPDATING_FEATURE_UPGRADE_PARAMS';
export const FEATURE_UPGRADE_PARAMS_UPDATED = 'FEATURE_UPGRADE_PARAMS_UPDATED';
export const ERROR_UPDATING_FEATURE_UPGRADE_PARAMS = 'ERROR_UPDATING_FEATURE_UPGRADE_PARAMS';

export function updateFeatureUpgradeParams(response) {
  return {
    type: FEATURE_UPGRADE_PARAMS_UPDATED,
    featureUpgradeParamsUpdated: response
  }
}

export const handleUpdateFeatureUpgrade = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_FEATURE_UPGRADE_PARAMS 
      });

      let data = new FormData();
      data.append('feature_upgrade[title]', params.title);
      data.append('feature_upgrade[short_description]', params.short_description);
      data.append('feature_upgrade[description]', params.description);
      data.append('feature_upgrade[permission]', params.permission);
      data.append('feature_upgrade[tag]', params.tag);
      data.append('feature_upgrade[position]', params.position);
      data.append('feature_upgrade[status]', params.status);
      data.append('feature_upgrade[url]', params.url);
      if (params.icon != undefined) {
        data.append('feature_upgrade[icon]', params.icon);
      }

      const response = await axios.put(
        `/v1/admin/feature_upgrades/${params.featureId}`,
        data,
        {
          cancelToken,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(updateFeatureUpgradeParams(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_FEATURE_UPGRADE_PARAMS,
        featureUpgradeParamsUpdated: {
          status: 'error',
          message: 'Error updating Feature Upgrade params'
        }
      });
    }
  };
}

export const SAVING_NOTIFICATION_PARAMS = 'SAVING_NOTIFICATION_PARAMS';
export const NOTIFICATION_PARAMS_SAVED = 'NOTIFICATION_PARAMS_SAVED';
export const ERROR_SAVING_NOTIFICATION_PARAMS = 'ERROR_SAVING_NOTIFICATION_PARAMS';

export function saveNotificationParams(response) {
  return {
    type: NOTIFICATION_PARAMS_SAVED,
    notificationParamsSaved: response
  }
}

export const handleSaveNotification = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVING_NOTIFICATION_PARAMS 
      });

      let data = new FormData();
      data.append('platform_notification[header]', params.header);
      data.append('platform_notification[sub_header]', params.sub_header);
      data.append('platform_notification[link_display_text]', params.link_display_text);
      data.append('platform_notification[link_url]', params.link_url);
      data.append('platform_notification[open_new_tab]', params.open_new_tab);
      data.append('platform_notification[tag]', params.tag);

      const response = await axios.post(
        `/v1/admin/platform_notifications`,
        data,
        {
          cancelToken,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          }
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(saveNotificationParams(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_SAVING_NOTIFICATION_PARAMS,
        notificationParamsSaved: {
          status: 'error',
          message: 'Error saving Notification params'
        }
      });
    }
  };
}

export const UPDATING_PLATFORM_NOTIFICATION_PARAMS = 'UPDATING_PLATFORM_NOTIFICATION_PARAMS';
export const PLATFORM_NOTIFICATION_PARAMS_UPDATED = 'PLATFORM_NOTIFICATION_PARAMS_UPDATED';
export const ERROR_UPDATING_PLATFORM_NOTIFICATION_PARAMS = 'ERROR_UPDATING_PLATFORM_NOTIFICATION_PARAMS';

export function updateNotificationParams(response) {
  return {
    type: PLATFORM_NOTIFICATION_PARAMS_UPDATED,
    notificationParamsUpdated: response
  }
}

export const handleUpdateNotification = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_PLATFORM_NOTIFICATION_PARAMS 
      });

      let data = new FormData();
      data.append('platform_notification[header]', params.header);
      data.append('platform_notification[sub_header]', params.sub_header);
      data.append('platform_notification[link_display_text]', params.link_display_text);
      data.append('platform_notification[link_url]', params.link_url);
      data.append('platform_notification[open_new_tab]', params.open_new_tab);
      data.append('platform_notification[tag]', params.tag);
      const response = await axios.put(
        `/v1/admin/platform_notifications/${params.notificationId}`,
        data,
        {
          cancelToken,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(updateNotificationParams(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_PLATFORM_NOTIFICATION_PARAMS,
        notificationParamsUpdated: {
          status: 'error',
          message: 'Error updating Platform Notification'
        }
      });
    }
  };
}

export const FETCHING_USERS_ADMIN = 'FETCHING_USERS_ADMIN';
export const USERS_ADMIN_FETCHED = 'USERS_ADMIN_FETCHED';
export const ERROR_FETCHING_USERS_ADMIN = 'ERROR_FETCHING_USERS_ADMIN';

export function fetchUsersForAdmin(response) {
  return {
    type: USERS_ADMIN_FETCHED,
    usersAdmin: response
  }
}

export const handleFetchUsersForAdmin = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_USERS_ADMIN 
      });

      const response = await axios.get(
        `/v1/admin/users`,
        {
          params,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
          cancelToken,
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(fetchUsersForAdmin(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_USERS_ADMIN,
        usersAdmin: {
          status: 'error',
          message: 'Error fetching users'
        }
      });
    }
  };
}

export const SETTING_USERS_ADMIN = 'SETTING_USERS_ADMIN';
export const USERS_ADMIN_SETTED = 'USERS_ADMIN_SETTED';
export const ERROR_SETTING_USERS_ADMIN = 'ERROR_SETTING_USERS_ADMIN';

export function setUpNewUser(response) {
  return {
    type: USERS_ADMIN_SETTED,
    setNewUser: response
  }
}

export const handleSetUpNewUser = (session, cancelToken, userId) => {
  return async dispatch => {
    try {
      dispatch({
        type: SETTING_USERS_ADMIN 
      });

      const response = await axios.post(
        `/v1/admin/users/${userId}/set_data_for_new_platform`,
        {},
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
          cancelToken,
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(setUpNewUser(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_SETTING_USERS_ADMIN,
        setNewUser: {
          status: 'error',
          message: 'Error fetching users'
        }
      });
    }
  };
}

////
export const LOG_AS_USER = 'LOG_AS_USER';
export const LOGGED_AS_USER = 'LOGGED_AS_USER';
export const ERROR_LOG_AS_USER = 'ERROR_LOG_AS_USER';

export function LogAsUser(response) {
  return {
    type: LOGGED_AS_USER,
    userSession: response
  }
}

export const handleLogAsUser = (session, cancelToken, userEmail) => {
  return async dispatch => {
    try {
      dispatch({
        type: LOG_AS_USER 
      });

      const response = await axios.post(
        `/v1/admin/users/log_in_as`,
        qs.stringify({
          user: {
            email: userEmail
          }
        }),
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Admin-User-Email': session.email,
            'X-Admin-User-Token': session.token
          },
          cancelToken,
        }
      ).catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.log('Request canceled', thrown.message);
        } else {
          
        }
      });

      dispatch(LogAsUser(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_LOG_AS_USER,
        userSession: {
          status: 'error',
          message: 'Error logging in as user'
        }
      });
    }
  };
}